// extracted by mini-css-extract-plugin
export var planCard = "_sa-0";
export var planList = "_sa-1";